<template>
  <div>
    <div class="item-head">
      <span class="badge badge-pill badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill badge-light">{{ item.id }}</span>
      <label class="mini-check"><input :id="`secure-${item.id}`" type="checkbox" v-model="item.security"> محافظت</label>
      <label class="mini-check"><input v-model="item.config['only_admin_edit']" :id="`admin_edit_${item.id}`" type="checkbox"> ادمین</label>
      <label class="mini-check"><input v-model="item.config['format_number']" :id="`format_number${item.id}`" type="checkbox"> جداسازی</label>
      <input type="text" class="form-control title-input" v-model="item.title" placeholder="عنوان">
      <input type="text" class="form-control pattern" placeholder="پترن" v-model="item.config.pattern">
      <b-icon class="bg-danger p-1 rounded-pill text-white" icon="trash" @click="deleteQuestion()"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextInput",
  props: {item: {}},
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>
.item-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.item-head .form-control,
.title-input {
  width: 220px;
  max-width: 100%;
  flex: 0 0 220px;
}
.pattern {
  width: 140px !important;
  flex: 0 0 140px !important;
}
.desc-input {
  margin-top: 10px;
  max-width: 420px;
}
.mini-check {
  font-size: 12px;
  margin: 0;
  white-space: nowrap;
}
</style>
